export const RAW_UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
] as const

export const DB_ONLY_CLICK_ID_KEYS = [
  'gclid',
  'gad_source',
  'fbclid',
  'ttclid',
  'naver_clid',
  'kakao_clid',
  'msclkid'
] as const

export type DeviceCategory = 'desktop' | 'mobile' | 'tablet'
export type RawUtmKey = (typeof RAW_UTM_KEYS)[number]
export type DbOnlyClickIdKey = (typeof DB_ONLY_CLICK_ID_KEYS)[number]
export type RawUtmProperties = Partial<Record<RawUtmKey, string>>
export type DbOnlyClickIds = Partial<Record<DbOnlyClickIdKey, string>>

export interface AttributionContext {
  contextId: string
  sessionSource: string
  sessionMedium: string
  rawUtm: RawUtmProperties
  dbOnlyClickIds: DbOnlyClickIds
  deviceCategory: DeviceCategory
  location: string
}

export type MixpanelAdditionalInfo = RawUtmProperties &
  DbOnlyClickIds & {
    context_id: string
    session_source: string
    session_medium: string
    device_category: DeviceCategory
    location: string
  }

export interface OAuthMixpanelEventProperties {
  $current_url?: string
}

export type MixpanelProperties = Record<string, unknown>
